import {
  Action,
  ActionCreateRequestPayload,
  ActionUpdateRequestPayload,
  SearchActionPayload,
  SearchActionResponse,
} from "@/domain/action.interface";
import { axios, transformAxiosError } from "../utils/axios.create";
import { OrganizationsResponse } from "@/domain/organizations.interface";

const search = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
}: SearchActionPayload): Promise<SearchActionResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
    search,
  });

  return axios
    .get(`/actions/search?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        actions: body.actions,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (data: ActionCreateRequestPayload) => {
  return axios
    .post("/actions", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: ActionUpdateRequestPayload;
}) => {
  return axios
    .put(`/actions/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/actions/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findAll = async (): Promise<Action[]> => {
  return axios
    .get("/actions")
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const ActionsService = {
  search,
  create,
  update,
  softDelete,
  findAll,
};
